import Group from 'components/utils/Group'
import Clickable from 'components/Common/Clickable'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Table from 'LuxKit/Tables/Table'
import { rem } from 'polished'
import styled from 'styled-components'

export const ContentWrapper = styled(Group)`
  margin: ${rem(24)} 0;
  padding: 0 ${rem(24)};
  width: ${rem(700)};
  max-width: 100%;
  box-sizing: border-box;
`

export const MapWrapper = styled.div`
  width: 100%;
  height: ${rem(300)};
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;
`

export const RoundedTable = styled(Table)`
  border-radius: ${props => props.theme.borderRadius.L};
`

export const TipCard = styled.div`
  padding: ${rem(12)} ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  border-radius: ${props => props.theme.borderRadius.M};
`

export const ThingsToDoCard = styled(ClickableListItem)`
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.M};
`

export const GridContainer = styled.div<{ $singleImage?: boolean }>`
  display: grid;
  grid-template-columns: ${props => props.$singleImage ? '1fr' : '2fr 1fr'};
  grid-template-rows: ${props => props.$singleImage ? '1fr' : '50% 50%'};
  gap: ${rem(4)};
  width: 100%;
  height: ${rem(340)};
  position: relative;
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;

  > :first-child {
    grid-column: ${props => props.$singleImage ? '1 / -1' : '1 / 2'};
    grid-row: ${props => props.$singleImage ? '1 / -1' : '1 / 3'};
  }
`

export const GalleryButtons = styled(Group)`
  pointer-events: auto;
  position: absolute;
  bottom: ${rem(16)};
  right: ${rem(16)};
`

export const GridImageClickable = styled(Clickable)`
  width: 100%;
  height: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
